import axios from 'axios';
import { General } from './services/general';

function AxiosInterceptors(token: string) {
    try {
        axios.interceptors.request.use(
            (config) => {
                if (config.headers['DisabledAuthorization'] === undefined) {
                    config.headers['Authorization'] = `Bearer ${token}`;
                } else {
                    if (config.headers['DisabledAuthorization']) {
                        delete config.headers['Authorization'];
                    }
                }
                if (config.url) {
                    const url = config.url;
                    const match = url.match(General.API_URL);
                    if (match) {
                        config.headers['ocp-apim-subscription-key'] =
                            '55d2ade0eaf5489893cfce977e034744';
                    }
                }
                return config;
            },
            (error) => {
                Promise.reject(error);
            }
        );
    } catch (ex) {
        console.error(ex);
    }
}

export default AxiosInterceptors;
